<script>
	import { updateDoc, doc, getFirestore } from "firebase/firestore";
	import SvelteFa from "$lib/components/SvelteFa.svelte";
	import {
		faCircleChevronLeft,
		faCircleChevronRight,
	} from "@fortawesome/free-solid-svg-icons";

	import { store } from "$lib/utilities/store";

	import Select from "./Select.svelte";

	export let collection;
	export let totalRecordCount;
	export let alias = collection;
	export let postUpdateFunction = () => {};
	export let updateProfile = true;
	export let options = [5, 10, 20, 35, 50, 100];

	let pages = [];

	$: totalPages = Math.ceil(
		totalRecordCount /
			$store.userProfile.collectionCriteria[collection].pageSize,
	);

	$: currentPage =
		($store.userProfile.collectionCriteria[collection].pageIndex || 0) + 1;
	$: middlePageCount = Math.min(totalPages - 2, 3); // Number of middle pages to show

	// Calculate start and end of middle pages
	$: middleStartPage = Math.max(
		currentPage - Math.floor(middlePageCount / 2),
		2,
	);
	$: middleEndPage = Math.min(
		middleStartPage + middlePageCount - 1,
		totalPages - 1,
	);

	$: pageSizeSelectDisabled = currentPage !== 1;

	$: (() => {
		pages = [];

		if (totalPages) {
			pages = [1]; // Always show first page

			if (totalPages <= 1) return;

			// Add ellipsis if necessary
			if (middleStartPage > 2) {
				pages.push(null); // Add ellipsis
			}
			// Add middle pages
			for (let i = middleStartPage; i <= middleEndPage; i++) {
				pages.push(i);
			}
			// Add ellipsis if necessary
			if (middleEndPage < totalPages - 1) {
				pages.push(null); // Add ellipsis
			}

			// Always show last page
			pages.push(totalPages);
		}
	})();

	let timeoutId;
	let previousPageSize;
	$: (() => {
		if (!updateProfile) return;
		if (
			$store.userProfile.collectionCriteria[collection].pageSize ===
			previousPageSize
		)
			return;
		previousPageSize =
			$store.userProfile.collectionCriteria[collection].pageSize;

		if (timeoutId) {
			clearTimeout(timeoutId);
		}
		timeoutId = setTimeout(async () => {
			console.log(`updating userProfile ${collection} size`);
			await updateDoc(
				doc(getFirestore(), `profiles/${$store.userProfile.uid}`),
				{
					collectionCriteria: {
						...$store.userProfile.collectionCriteria,
						[collection]:
							$store.userProfile.collectionCriteria[collection],
					},
				},
			);

			postUpdateFunction();
		}, 1000);
	})();

	let previousPageIndex;
	$: (() => {
		if (!updateProfile) {
			postUpdateFunction();
			return;
		}
		if (
			$store.userProfile.collectionCriteria[collection].pageIndex ===
			previousPageIndex
		)
			return;
		previousPageIndex =
			$store.userProfile.collectionCriteria[collection].pageIndex;

		if (timeoutId) {
			clearTimeout(timeoutId);
		}
		timeoutId = setTimeout(async () => {
			console.log(`updating userProfile ${collection} index`);
			await updateDoc(
				doc(getFirestore(), `profiles/${$store.userProfile.uid}`),
				{
					collectionCriteria: {
						...$store.userProfile.collectionCriteria,
						[collection]:
							$store.userProfile.collectionCriteria[collection],
					},
				},
			);

			postUpdateFunction();
		}, 1000);
	})();

	const stepCounter = (e) => {
		const dir = e.target.closest("button").getAttribute("setValue");

		if (dir === "+") {
			if (
				$store.userProfile.collectionCriteria[collection].pageIndex <
				totalPages - 1
			) {
				$store.userProfile.collectionCriteria[collection].pageIndex++;
			}
			return;
		}

		if (dir === "-") {
			if (
				$store.userProfile.collectionCriteria[collection].pageIndex > 0
			) {
				$store.userProfile.collectionCriteria[collection].pageIndex--;
			}
			return;
		}

		$store.userProfile.collectionCriteria[collection].pageIndex =
			Number(dir);
	};
</script>

<div class="flex justify-center">
	<button
		class="p-1 m-1 btn sm:m-2 sm:p-2"
		setValue="-"
		on:click|preventDefault={stepCounter}
	>
		<SvelteFa icon={faCircleChevronLeft} size="1.5x" />
	</button>

	{#each pages as page}
		{#if page === $store.userProfile.collectionCriteria[collection].pageIndex + 1}
			<div class="p-1 m-1 btn btn-neutral sm:m-2 sm:p-2">{page}</div>
		{:else if page === null}
			<div class="p-1 m-1 btn sm:m-2 sm:p-2">...</div>
		{:else}
			<button
				class="p-1 m-1 btn sm:m-2 sm:p-2"
				setValue={page - 1}
				on:click|preventDefault={stepCounter}
			>
				{page}
			</button>
		{/if}
	{/each}

	<button
		class="p-1 m-1 btn sm:m-2 sm:p-2"
		setValue="+"
		on:click|preventDefault={stepCounter}
	>
		<SvelteFa icon={faCircleChevronRight} size="1.5x" />
	</button>

	<div class="m-1 sm:m-2">
		<Select
			disabled={pageSizeSelectDisabled}
			name={`${alias}-page-size`}
			bind:value={
				$store.userProfile.collectionCriteria[collection].pageSize
			}
			{options}
		/>
	</div>
</div>
